import validate from "/Users/bdotzour/Development/thorne-site-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import affiliate_45referral_45tracking_45global from "/Users/bdotzour/Development/thorne-site-nuxt/src/middleware/affiliateReferralTracking.global.ts";
import manifest_45route_45rule from "/Users/bdotzour/Development/thorne-site-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  affiliate_45referral_45tracking_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}